import React from 'react';

interface SectionProps {
    title: string;
    children: React.ReactNode;
    id?: string;
    count?: number;
}

const Section = React.forwardRef<HTMLElement, SectionProps>(({ title, children, id, count }, ref) => {
    const headingId = id || `section-${title?.toLowerCase().replace(/\s+/g, '-')}`;
    return (
        <section
            className="profile-section"
            ref={ref}
            id={headingId}
            aria-labelledby={`${headingId}-heading`}
        >
            <h2 id={`${headingId}-heading`}>
                {title}
                {count != null && (
                    <span className="section-count" aria-label={`${count} items`}>
                        {count}
                    </span>
                )}
            </h2>
            {children}
        </section>
    );
});

Section.displayName = 'Section';
export default React.memo(Section);
